export const VERSION = '@pf2m-version';
export const REACT_APP_VERSION = '@pf2m-frontend-version';
export const getVersion = () => localStorage.getItem(VERSION);

export const setVersion = version => localStorage.setItem(VERSION, version);

export const normalizeVersions = ({ local, current }) => ({
  localVersion: Number(local.match(/\d+/g).join('')),
  currentVersion: Number(current.match(/\d+/g).join('')),
});

export const clearCache = () => {
  if ('caches' in window) {
    caches.keys().then((keys) => {
      keys.forEach(k => caches.delete(k));
    });
  }
};

export const checkCurrentReactAppVersion = () => {
  // TODO Precisa atualizar a questão de conseguir puxar a versão por
  // process.env
  const appVersion = 'v2.15.05.07';
  const version = localStorage.getItem(REACT_APP_VERSION);

  if (appVersion !== version) {
    localStorage.clear();
    localStorage.setItem(REACT_APP_VERSION, appVersion);
    sessionStorage.clear();
  }
};

export const validateVersion = ({ current }) => {
  const local = getVersion();
  if (!local) return clearCache();

  const { currentVersion, localVersion } = normalizeVersions({ current, local });

  if (currentVersion > localVersion) return clearCache();
  return null;
};
